<h3 class="mat-h3">Seleccione la fecha de inicio de la autorizacion presencial <br>de <em class="opacity-medium">{{alumno.apellidosNombres}}</em></h3>
<mat-dialog-content>
    <mat-form-field class="full-width" appearance="standard">
        <mat-label>Elija una fecha</mat-label>
        <input [formControl]="fechaForm" matInput [matDatepicker]="picker">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close  cdkFocusInitial>Cancelar</button>
    <button mat-raised-button color="primary" (click)="submit()">Aceptar</button>
</mat-dialog-actions>
